import { createContext, useContext, useMemo, type ReactNode } from 'react'

interface OrgContextValue {
  orgId: string
  /** 6-digit short code used in user-facing URLs (e.g. booking links). */
  shortCode: string
  orgName: string
}

const OrgContext = createContext<OrgContextValue | null>(null)

interface OrgProviderProps {
  children: ReactNode
  orgId: string
  shortCode: string
  orgName?: string
}

export function OrgProvider({
  children,
  orgId,
  shortCode,
  orgName = 'Organization',
}: OrgProviderProps) {
  const value = useMemo(() => ({ orgId, shortCode, orgName }), [orgId, shortCode, orgName])

  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>
}

export function useOrg(): OrgContextValue {
  const context = useContext(OrgContext)
  if (!context) {
    throw new Error('useOrg must be used within OrgProvider')
  }
  return context
}

export function useOrgOptional(): OrgContextValue | null {
  return useContext(OrgContext)
}

export { OrgContext }
